import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

const serviceLinks = [
  { label: 'AI Lead Capture', href: '/services' },
  { label: 'Smart Scheduling', href: '/services' },
  { label: 'Automated Follow-Up', href: '/services' },
  { label: 'Pipeline Dashboard', href: '/services' },
];

const companyLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'Industries', href: '/industries' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch('https://readdy.ai/api/form/d6u4lvf6t0doov8ffo10', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#F5F5F7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16 border-b border-black/8">
          <div className="lg:col-span-5">
            <Link to="/" className="inline-block mb-5">
              <img
                src="https://public.readdy.ai/ai/img_res/d6ab1378-0b1c-45b1-a3cd-1269214cedf2.png"
                alt="Omega Solutions AI"
                className="w-[90px] h-[90px] object-contain"
              />
            </Link>
            <p className="text-[#6E6E73] text-sm leading-relaxed mb-7 max-w-xs">
              Automation systems for home service businesses and solar companies.
              Capture every lead. Book every job.
            </p>
            {submitted ? (
              <p className="text-emerald-700 text-sm font-medium flex items-center gap-2">
                <i className="ri-check-circle-line" />
                You&apos;re on the list!
              </p>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(ev) => setEmail(ev.target.value)}
                  placeholder="Your email"
                  required
                  className="flex-1 bg-white border border-black/10 text-[#0A0A0A] placeholder-[#AEAEB2] text-sm px-4 py-2.5 rounded-full focus:outline-none focus:border-black/30"
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="whitespace-nowrap bg-[#0A0A0A] text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-[#1D1D1F] transition-colors cursor-pointer disabled:opacity-50"
                >
                  {submitting ? '...' : 'Subscribe'}
                </button>
              </form>
            )}
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <h4 className="text-[#0A0A0A] text-xs font-semibold mb-5 uppercase tracking-widest">
              Services
            </h4>
            <ul className="space-y-3.5">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-[#6E6E73] text-sm hover:text-[#0A0A0A] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-[#0A0A0A] text-xs font-semibold mb-5 uppercase tracking-widest">
              Company
            </h4>
            <ul className="space-y-3.5">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-[#6E6E73] text-sm hover:text-[#0A0A0A] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <div className="flex gap-3">
                {['linkedin-box', 'twitter-x', 'facebook-box'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    rel="nofollow"
                    className="w-8 h-8 flex items-center justify-center rounded-full bg-black/6 text-[#6E6E73] hover:text-[#0A0A0A] hover:bg-black/10 transition-colors cursor-pointer"
                  >
                    <i className={`ri-${icon}-fill text-sm`} />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#AEAEB2] text-xs tracking-tight">
            &copy; {new Date().getFullYear()} Omega Solutions AI. All rights reserved.
          </p>
          <p className="text-[#AEAEB2] text-xs">
            Automation for home services &amp; solar
          </p>
        </div>
      </div>
    </footer>
  );
}
